
export enum ImportantAlertType {
  Success = 1, // important
  Danger = 2,
  Info = 3,
  Warning = 4
}
